import { useEventListener } from './useEventListener.js';
import { inBrowser } from '@varlet/shared';
import { unref } from 'vue';
export function useClickOutside(target, type, listener) {
    if (!inBrowser()) {
        return;
    }
    const handler = (event) => {
        const element = unref(target);
        if (element && !element.contains(event.target)) {
            listener(event);
        }
    };
    useEventListener(document, type, handler);
}
